<div class="row" style="font-weight: 600">
    <div class="col">
        @switch (mode) {
        @case ('highlights') {
        <h2>{{'highlights'| translate}}</h2>
        }
        @case ('technicaldata') {
        <h2>{{'technicaldata'| translate}}</h2>
        }
        @case ('detail') {
        <h2>{{title}}</h2>
        }
        }
    </div>
</div>

<div class="row">
    <div class="col-md">
        <div [innerHTML]="htmlstring">
        </div>
    </div>
</div>